import {inject, Injectable} from "@angular/core";
import {Meta, Title} from "@angular/platform-browser";
import {ActivationEnd, Router} from "@angular/router";
import {filter, map, of, switchMap} from "rxjs";
import {EventDataService} from "./event-data.service";

const DEFAULT_DESCRIPTION = 'Nexus for FLL is at the center of the best FIRST LEGO League events- improving the experience for teams and volunteers.';

@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  private readonly router = inject(Router);
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);
  private readonly eventDataService = inject(EventDataService);

  constructor() {
    this.router.events.pipe(
      filter((e): e is ActivationEnd => e instanceof ActivationEnd),
      filter(e => !!e.snapshot?.component && !e.snapshot?.children?.length),
      switchMap(e => {
        const snap = e.snapshot;
        const regionKey = snap.params?.['regionKey'];
        const eventKey = snap.params?.['eventKey'];
        const teamNumber = snap.params?.['teamNumber'];
        let prefix = snap.data?.['title'] ? `${snap.data['title']} | ` : '';
        if(teamNumber) {
          prefix += `${teamNumber} | `;
        }

        const description = snap.data?.['description'] ||  DEFAULT_DESCRIPTION;

        if(regionKey) {
          return this.eventDataService.getEventOrRegionName(regionKey, eventKey).pipe(map(name => ({title: `${prefix}${name} | Nexus`, description})));
        }

        return of({title: prefix ? `${prefix}Nexus` : `Nexus for FLL`, description});
      }),
    ).subscribe(meta => {
      this.title.setTitle(meta.title);
      this.meta.updateTag({name: 'description', content: meta.description});
    });
  }
}
